import axios from 'axios'
import moment from 'moment'
import store from '@/store'

const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: process.env.VUE_APP_API_TIMEOUT,
  withCredentials: true
})

service.interceptors.request.use(
  config => {
    if ([ '/auth/me', ].indexOf(config.url) === -1) {
      config.request_at = new moment().format('Y-MM-DDTHH:mm:ss.SSS')
      store.dispatch('uiRequest', config.request_at)
    }
    config.headers = { 'X-Requested-With': 'XMLHttpRequest' }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    if (response && response.config && response.config.request_at) {
      setTimeout(() => {
        store.dispatch('uiResponse', response.config.request_at)
      }, 100)
    }

    const res = response.data
    if (res && res.message) {
      store.dispatch('uiPushFlash', { variant: 'success', text: res.message, })
    }

    return Promise.resolve(response)
  },
  error => {
    console.log('err')// for debug
    console.log(error)// for debug

    if (error && error.config && error.config.request_at) {
      setTimeout(() => {
        store.dispatch('uiResponse', error.config.request_at)
      }, 100)
    }
     
    const code = error && error.response ? error.response.status : null

    let text = error && error.response && error.response.data && error.response.data.message ? error.response.data.message : null
     
    switch (code) {
      case null:
      case 401: {
        store.dispatch('authSignout')
        text = 'サインアウトしました。'
        break
      }
      case 404: {
        text = text ? text : 'データが見つかりません。'
        break
      }
      case 422: {
        break
      }
      default: {
        text = text ? text : 'エラーが発生しました。もう一度、操作をお試しください。'
        break
      }
    }

    store.dispatch('uiPushFlash', { variant: 'danger', text: text, })

    return Promise.reject(error)
  }
)

export default service

